var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#151419"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 8.34895L18 10.7555C16.7733 10.7555 15.6365 10.3562 14.7087 9.67861V14.5699C14.7087 17.0127 12.7553 19 10.3543 19C9.42648 19 8.5661 18.7023 7.85887 18.1971L7.85766 18.1958C6.73544 17.3937 6 16.0677 6 14.5694C6 12.1267 7.95333 10.1393 10.3544 10.1393C10.5536 10.1393 10.7489 10.156 10.9412 10.1825L10.9411 12.6401C10.7553 12.581 10.559 12.5466 10.3543 12.5466C9.25775 12.5466 8.36568 13.4543 8.36568 14.5699C8.36568 15.3467 8.7989 16.0217 9.43186 16.3606C9.70784 16.5084 10.0213 16.5931 10.3542 16.5931C11.4254 16.5931 12.2993 15.7262 12.3391 14.646L12.3428 5H14.7086C14.7086 6.89478 16.2385 8.34895 17.9999 8.34895Z",
    fill: "#151419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.2b01410fa6cbc2a419159b36a576ecbd.svg";
export { ForwardRef as ReactComponent };